export enum NotificationMessageType {
    IS_NOT_CALIBRATED = 1,
    IS_NOT_CALIBRATED_PLANNED_DEVELOPMENT = 2
}
